import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoggingService } from '@services/logging.service';

@Component({
	selector: 'qe-terms-of-service-modal',
	templateUrl: './terms-of-service-modal.component.html',
	styleUrls: ['./terms-of-service-modal.component.scss'],
})
export class TermsOfServiceModalComponent {
	constructor(
		private readonly dialog: MatDialog,
		private readonly loggingService: LoggingService
	) {}

	public openEmbracePolicyModal(ev: UIEvent): void {
		ev.preventDefault();
		import(`@shared/embrace-policy-modal/embrace-policy-modal.component`)
			.then((c) => this.dialog.open(c.EmbracePolicyModalComponent))
			.catch((err) => this.loggingService.error(err));
	}

	public openStateFraudModal(ev: UIEvent): void {
		ev.preventDefault();
		import(`@shared/state-fraud-modal/state-fraud-modal.component`)
			.then((c) => this.dialog.open(c.StateFraudModalComponent))
			.catch((err) => this.loggingService.error(err));
	}
}
